import script from "./Vendors.vue?vue&type=script&setup=true&lang=ts"
export * from "./Vendors.vue?vue&type=script&setup=true&lang=ts"

import "./Vendors.vue?vue&type=style&index=0&id=a3623454&lang=css"

const __exports__ = script;

export default __exports__